import { render, staticRenderFns } from "./Gastronomy.vue?vue&type=template&id=34dc2a48&scoped=true"
import script from "./Gastronomy.vue?vue&type=script&lang=js"
export * from "./Gastronomy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc2a48",
  null
  
)

export default component.exports